// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"f2ab9fa0","104":"35cade6e","164":"c49bbdd0"}[chunkId] + ".chunk.js";
};